<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in calcList" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "EchelonType",
    props: ["value", "productType"],

    computed: {
      calcList() {
        this.data = "";
        if (!this.type) {
          return [];
        }
        if (this.type == 1) {
          return [{
              name: "电池包直接梯级利用",
              value: 1
            },
            {
              name: "电池模块直接梯级利用",
              value: 2
            }
          ]
        }
        if (this.type == 2) {
          return [
            {
              name: "电池模块直接梯级利用",
              value: 2
            },
            {
              name: "电池单体梯级利用",
              value: 3
            }
          ]
        }
        if (this.type == 3) {
          return [
            {
            name: "电池单体梯级利用",
            value: 3
          }]
        }
      }
    },
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }
      },
      productType: {
        immediate: true,
        handler: function(value) {
          this.type = value;
        }
      }

    },
    data() {
      return {
        data: "",
        type: "",
        list: [
          {
             name: "电池包直接梯级利用",
            value: 1
          },
          {
            name: "电池模块直接梯级利用",
            value: 2
          },
          {
            name: "电池单体梯级利用",
            value: 3
          }
        ]
      }
    },
    methods: {
      handleChange(value) {
        this.data = value;
        this.$emit("input", value)
      }
    }
  }
</script>

<style scoped>

</style>
